import { SxProps, Theme } from '@mui/material';

export const breadcrumbsContainerSx: SxProps<Theme> = {
    position: 'sticky',
    top: 0,
    py: 1,
    zIndex: theme => theme.zIndex.appBar,
    mb: '2px',
    mx: '-2px',
    backgroundColor: theme => theme.palette.background.paper,
};

export const breadcrumbsSx: SxProps<Theme> = {
    px: 1,
    py: 0.5,
    backgroundColor: 'grey.100',
    border: '1px solid',
    borderColor: 'grey.300',
    borderRadius: 1,
};

export const breadcrumbLinkSx: SxProps<Theme> = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    px: 1,
    py: 0.5,
    borderRadius: 1,
    '&:hover': {
        backgroundColor: 'grey.300',
    },
};

export const breadcrumbIconSx: SxProps<Theme> = {
    fontSize: '1.2rem',
};
